import React, {useEffect, useMemo, useState} from "react";
import avatarDefault from "../../../images/avatardefault.png";
import {Spinner} from "../index";
import {useIntl} from "react-intl";
import {getCachedImageUrl} from "../../../utils/utils";
import {Link} from "react-router-dom";
import auth from "../../../utils/authentication";

import './user-info.scss';
import {SquadDiskUsersApi} from "../../../apis/squaddisk-users/SquadDiskUsersApi";

type Props = {
    uid?: string;
    initialUser?: any;
    setUserInParentObject?: (user: any) => void;
    nameReplace?: string;
    nameDecorations?: React.ReactNode;
    nameOptions?: React.ReactNode;
    userExtraInfo?: React.ReactNode;
    className?: string;
    loading?: boolean;
}

function UserInfo({
                      uid,
                      initialUser,
                      setUserInParentObject,
                      nameReplace,
                      nameDecorations,
                      nameOptions,
                      userExtraInfo,
                      className,
                      loading
                  }: Props) {

    const intl = useIntl();

    const [user, setUser] = useState(initialUser);

    useEffect(() => {
        if (initialUser?.displayName) {
            setUser(initialUser);
            return;
        }
        SquadDiskUsersApi.getUserInfoByUid({uid}).then(res => {
            setUser(res.data)
            if (setUserInParentObject) {
                setUserInParentObject(res.data);
            }
        });
    }, [initialUser, uid, setUserInParentObject]);

    const linkUser = useMemo(() => {
        if (!user?.uid) {
            return '';
        }
        const isAuthedUser = auth.currentUser?.uid === user?.uid;
        if (isAuthedUser) {
            return `/my-profile/posts`;
        } else {
            return `/user/${user.displayName}/${user.userCode}/posts`;
        }
    }, [user])

    if (!user?.uid || !user?.userCode) {
        return (
            <div>
                <Spinner className="spinner-sm"/>
            </div>
        )
    }

    return (
        <div className="user-info">
            <div className="d-flex flex-row align-items-center">
                <img className="user-info__img" alt={user.displayName}
                     src={user.photoURL ? getCachedImageUrl(user.photoURL) : avatarDefault}/>
                <div className="d-flex flex-column" style={{width: "100%"}}>
                    {user.userCode &&
                        <div>
                            <div className="d-flex flex-row justify-content-between">
                                <Link to={linkUser}
                                      className={"ms-2 text-body-emphasis " + className}>
                                    {nameReplace ? intl.formatMessage({id: nameReplace}).replace('%DISPLAY_NAME%', user.displayName) : user.displayName}
                                    {nameDecorations}
                                </Link>
                                {!loading && nameOptions}
                            </div>
                            <span className="ms-2 d-flex flex-row justify-content-between" style={{
                                fontSize: "small",
                                fontWeight: "lighter"
                            }}>#{user.userCode}{!loading && userExtraInfo}</span>
                        </div>
                    }
                </div>
                {loading && <div>
                    <Spinner className="spinner-sm"/>
                </div>}
            </div>
        </div>
    )
}

export default UserInfo;
